'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.controller("ClassificationValeursEditionPopinController", function ($scope, $q, $http, $translate, lovService, $notifications, $dialogBox, classificationService, contextService, $element, chartUtils, $rootScope) {
  var cible = $scope.classification.cible;
  var originalClassificationValeurs = $scope.classification.valeurs;
  $scope.classificationValeurs = angular.copy(originalClassificationValeurs);
  $scope.addClassificationValue = function () {
    $scope.classificationValeurs.push({
      id: null,
      nom: "",
      color: chartUtils.getGraphColor($scope.classificationValeurs.length),
      new: true
    });
  };
  var plainToTable = function plainToTable(text) {
    var table = [];
    var rowSeparator = '\n';
    if (text.indexOf('\r\n') > -1) {
      rowSeparator = '\r\n';
    }
    _.each(text.trim(rowSeparator).split(rowSeparator), function (rowData, lineIdx) {
      table[lineIdx] = [];
      _.each(rowData.split('\t'), function (cellData, rowIdx) {
        table[lineIdx][rowIdx] = cellData;
      });
    });
    return table;
  };
  $scope.createFromClipboard = function () {
    navigator.clipboard.read().then(function (clipboards) {
      for (var i = 0; i < clipboards.length; i++) {
        var clipboardItem = clipboards[i];
        var type = 'text/plain';
        clipboardItem.getType(type).then(function (blob) {
          blob.text().then(function (text) {
            // parsed est un tableau (ligne) de tableau (colonnes) dont on ne prendra que le premier element comme nom
            var parsed = plainToTable(text);
            if (parsed.length > 0) {
              var values = [];
              var resume = "";
              for (var row = 0; row < parsed.length; row++) {
                var valeurNom = parsed[row];
                if (valeurNom != null && valeurNom[0] != null && _.trim(valeurNom[0]).length > 0) {
                  valeurNom = _.trim(valeurNom[0]);
                  if (valeurNom.length > 40) {
                    valeurNom = valeurNom.substring(0, 40);
                  }
                  values.push({
                    id: null,
                    nom: "" + valeurNom,
                    color: chartUtils.getGraphColor($scope.classificationValeurs.length + values.length)
                  });

                  // résumé pour la popup de confirmation
                  if (row === 20) {
                    resume += ", ...";
                  }
                  if (row < 20) {
                    if (resume.length !== 0) {
                      resume += ", ";
                    }
                    resume += valeurNom;
                  }
                }
              }
              $dialogBox.confirm({
                title: "Ajout de valeurs",
                html: "Etes-vous sûr de vouloir ajouter ces " + values.length + " valeurs issues du presse-papier ?<br/>" + "<div>" + resume + "</div>"
              }).then(function () {
                {
                  for (var _row = 0; _row < values.length; _row++) {
                    $scope.classificationValeurs.push(values[_row]);
                  }

                  // retire les valeurs null qui seraient encore présentes
                  $scope.classificationValeurs = _.filter($scope.classificationValeurs, function (v) {
                    return v.nom != null && v.nom.trim().length > 0;
                  });
                  $notifications.info(values.length + " valeurs ajoutées");

                  // on force une revalidation avec invalidation (touch) des champs
                  _.delay(function () {
                    $rootScope.$emit("tlValidatedField:validate");
                    $scope.$apply();
                  }, 100);
                }
              });
            } else {
              $notifications.info("Aucune donnée disponible dans le presse-papier");
            }
          });
        });
      }
    });
  };
  if ($scope.classificationValeurs.length === 0) {
    $scope.addClassificationValue();
  }
  $scope.hasNomEnDoublon = function () {
    return _.some($scope.classificationValeurs, function (c) {
      return $scope.nomEnDoublon(c.nom);
    });
  };
  $scope.nomEnDoublon = function (nom) {
    return _.filter($scope.classificationValeurs, function (c) {
      return nom === c.nom;
    }).length > 1;
  };
  $scope.classificationValeursFormConfig = {
    url: function url() {
      return '/rest/saisie/champAdditionnel/' + $scope.classification.id + '/valeurs/';
    },
    data: function data() {
      return $scope.classificationValeurs;
    },
    customValidation: function customValidation() {
      var errors = [];
      for (var i = 0; i < $scope.classificationValeurs.length; i++) {
        var valeur = $scope.classificationValeurs[i];
        if (valeur.nom == null || valeur.nom.trim().length === 0) {
          errors.push({
            fieldName: 'classification.valeur' + i,
            message: 'La valeur est obligatoire.'
          });
        }
        if (valeur.nom != null && $scope.nomEnDoublon($scope.classificationValeurs[i].nom)) {
          errors.push({
            fieldName: 'classification.valeur' + i,
            message: 'Il existe déjà une autre valeur portant ce nom.'
          });
        }
      }
      return errors;
    },
    onSuccess: function onSuccess(savedClassificationValeurs) {
      _.extend($scope.classificationValeurs, savedClassificationValeurs);
      classificationService.$reload();
      contextService.refreshData();
      $notifications.info("Valeurs de la classification enregistrées");
      $scope.$close($scope.classificationValeurs);
    },
    onError: function onError(errors) {
      $scope.errors = errors;
      return;
    }
  };
  $scope.remove = function (value) {
    if (value.id != null) {
      $http.get('/rest/saisie/champAdditionnel/' + $scope.classification.id + '/valeur/' + value.id + '/utilisee').then(function (response) {
        if (response.data.response === false) {
          var index = _.indexOf($scope.classificationValeurs, value);
          $scope.classificationValeurs.splice(index, 1);
        } else {
          value.deleteErreur = 'Cette valeur est utilisée et n\'a pas pu être supprimée.';
        }
      });
    } else {
      var index = _.indexOf($scope.classificationValeurs, value);
      $scope.classificationValeurs.splice(index, 1);
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/classification/valeur/classificationValeursEditionPopin.js
// module id = 2692
// module chunks = 13